import React from 'react';

const ChoiceDistributor = ({ currentStep, configData, selection, onSelect }) => {
    const renderChoices = () => {
        // Ensure configData and models are available
        if (!configData || !configData.models) {
            return <div>Loading configuration...</div>;
        }

        const modelData = configData.models.find(m => m.name === selection.model);

        // Find the selected size data to access nested options
        const sizeData = modelData && selection.size 
            ? modelData.sizes.find(s => s.name === selection.size)
            : null;

        switch (currentStep) {
            case 0: // Model Selection
                return (
                    <div className="choices choices--models">
                        {configData.models.map(model => (
                            <div className={`choice ${selection.model && model.name === selection.model ? 'is-active' : ''}`} key={model.name} onClick={() => onSelect(0, model.name)}>
                                <div className="choice__image">
                                    <img src={model.image} alt={model.name} />
                                </div>
                                <div className="choice__title">{model.name}</div>
                            </div>
                        ))}
                    </div>
                );
            case 1: // Size Selection
                if (!modelData || !modelData.sizes) return null;
                return (
                    <div className="choices choices--sizes">
                        {modelData.sizes.map(size => (
                            <div className={`choice ${selection.size && size.name === selection.size ? 'is-active' : ''}`} key={size.name} onClick={() => onSelect(1, size.name)}>
                                <div className="choice__image">
                                    <img src={size.image} alt={size.name} />
                                </div>
                                <div className="choice__title">{size.name}</div>
                            </div>
                        ))}
                    </div>
                );
            case 2: // Structure Color Selection
                if (!sizeData || !sizeData.structure || !sizeData.structure.colors) return null;
                return (
                    <div className="choices choices--colors">
                        {sizeData.structure.colors.map(color => (
                            <div className={`choice ${selection.structureColor && color.name === selection.structureColor.name ? 'is-active' : ''}`} key={color.name} onClick={() => onSelect(2, color)}>
                                <div className="choice__image">
                                    <img src={color.preview} alt={color.name} />
                                </div>
                                <div className="choice__title">{color.name}</div>
                            </div>
                        ))}
                    </div>
                );
            case 3: // Canopy Color Selection
                if (!sizeData || !sizeData.canopy || !sizeData.canopy.colors) return null;
                return (
                    <div className="choices choices--colors">
                        {sizeData.canopy.colors.map(color => (
                            <div className={`choice ${selection.canopyColor && color.name === selection.canopyColor.name ? 'is-active' : ''}`} key={color.name} onClick={() => onSelect(3, color)}>
                                <div className="choice__image">
                                    <img src={color.preview} alt={color.name} />
                                </div>
                                <div className="choice__title">{color.name}</div>
                            </div>
                        ))}
                    </div>
                );
            case 4: // Valance Selection
                if (!sizeData || !sizeData.valances || !sizeData.valances.options) return null;
                return (
                    <div className="choices choices--valances">
                        <div className={`choice ${selection.valance === null ? 'is-active' : ''}`} onClick={() => onSelect(4, null)}>
                            <div className="choice__title">No Valance</div>
                        </div>
                        {sizeData.valances.options.map(valance => (
                            <div className={`choice ${selection.valance && valance.name === selection.valance.name ? 'is-active' : ''}`} key={valance.name} onClick={() => onSelect(4, valance)}>
                                <div className="choice__image">
                                    <img src={valance.preview} alt={valance.name} />
                                </div>
                                <div className="choice__title">{valance.name}</div>
                            </div>
                        ))}
                    </div>
                );
            case 5: // Fringe Selection
                if (!selection.valance || !sizeData || !sizeData.fringes || !sizeData.fringes.options) return null; // Skip if no valance selected
                return (
                    <div className="choices choices--fringe">
                        {sizeData.fringes.options.map(fringe => (
                            <div className={`choice ${(selection.hasFringe && fringe.name === "Yes") || (!selection.hasFringe && fringe.name === "No") ? 'is-active' : ''}`} key={fringe.name} onClick={() => onSelect(5, fringe.value)}>
                                <div className="choice__title">{fringe.name}</div>
                            </div>
                        ))}
                    </div>
                );
            case 6: // Base Selection
                if (!sizeData || !sizeData.bases || !sizeData.bases.options) return null;
                return (
                    <div className="choices choices--bases">
                        {sizeData.bases.options.map(base => (
                            <div className={`choice ${selection.base && base.glb === selection.base ? 'is-active' : ''}`} key={base.name} onClick={() => onSelect(6, base.glb)}>
                                <div className="choice__image">
                                    <img src={base.preview} alt={base.name} />
                                </div>
                                <div className="choice__title">{base.name}</div>
                            </div>
                        ))}
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="widget__content">
            {renderChoices()}
        </div>
    );
};

export default ChoiceDistributor;
